/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Theme from '../ui/Theme';
import CloudIcon from '../../assets/UploadIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

const CustomUploadButton = ({ name, id, handleImageUpload, styles, disabled, accept = 'image/*' }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        name={name}
        accept={accept}
        className={classes.input}
        id={id ?? 'upload-image'}
        multiple
        onChange={handleImageUpload}
        type="file"
        disabled={disabled}
      />
      <label htmlFor={id ?? 'upload-image'}>
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={styles}
          disableElevation
          component="span"
          disabled={disabled}
        >
          <div className={classes.btnStyle}>Upload</div>
        </Button>
      </label>
    </div>
  );
};
export default React.memo(CustomUploadButton);
